enum WorkspaceProjectImpactFrameworkStatus {
  'Draft' = 'Draft',
  'Published' = 'Published',
}

export default WorkspaceProjectImpactFrameworkStatus
